'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Social = require('../social/Social');
var _Social2 = _interopRequireDefault(_Social);
var _List = require('../list/List');
var _List2 = _interopRequireDefault(_List);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Recipe = function Recipe(props) {
  return _react2.default.createElement('div', {
    className: 'recipe ' + props.className
  }, _react2.default.createElement('h1', {
    className: 'recipe__name'
  }, props.recipe.name), props.recipe.description ? _react2.default.createElement('p', {
    className: 'recipe__description'
  }, props.recipe.description) : null, props.socialEnabled ? _react2.default.createElement(_Social2.default, _extends({
    className: 'recipe__social',
    emailSubject: props.recipe.name,
    emailMessage: props.recipe.description,
    facebookImage: props.recipe.facebook_image,
    facebookSubject: props.recipe.name,
    facebookMessage: props.recipe.description,
    pinterestImage: props.recipe.pinterest_image,
    pinterestMessage: props.recipe.description,
    twitterMessage: props.recipe.description
  }, props.social)) : null, _react2.default.createElement('div', {
    className: 'recipe__lists ' + (props.recipe.product_image ? 'recipe__lists--has-product' : '')
  }, props.recipe.product_image ? _react2.default.createElement('img', {
    src: props.recipe.product_image,
    className: 'recipe__product-image',
    alt: props.recipe.product_image_alt
  }) : null, _react2.default.createElement(_List2.default, {
    className: 'recipe__ingredients',
    items: props.recipe.ingredients_list,
    title: props.ingredientsTitle
  }), _react2.default.createElement(_List2.default, {
    className: 'recipe__directions',
    items: props.recipe.directions_list,
    title: props.directionsTitle
  })), props.recipe.servings ? _react2.default.createElement('p', {
    className: 'recipe__servings'
  }, props.servingsTitle, ' ', props.recipe.servings) : null);
};
Recipe.defaultProps = {
  className: '',
  directionsTitle: 'Directions',
  ingredientsTitle: 'Ingredients',
  servingsTitle: 'Serving Size:',
  social: {},
  socialEnabled: true
};
Recipe.propTypes = {
  className: _propTypes2.default.string,
  directionsTitle: _propTypes2.default.string,
  ingredientsTitle: _propTypes2.default.string,
  recipe: _propTypes2.default.shape({
    description: _propTypes2.default.string,
    directions_list: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    facebook_image: _propTypes2.default.string,
    ingredients_list: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    name: _propTypes2.default.string,
    pinterest_image: _propTypes2.default.string,
    product_image: _propTypes2.default.string,
    product_image_alt: _propTypes2.default.string,
    servings: _propTypes2.default.string
  }).isRequired,
  servingsTitle: _propTypes2.default.string,
  social: _propTypes2.default.shape({
    emailSubject: _propTypes2.default.string,
    emailMessage: _propTypes2.default.string,
    emailUrl: _propTypes2.default.string,
    facebookAppId: _propTypes2.default.string,
    facebookIcon: _propTypes2.default.oneOf(['default', 'square']),
    facebookImage: _propTypes2.default.string,
    facebookMessage: _propTypes2.default.string,
    facebookSubject: _propTypes2.default.string,
    facebookUrl: _propTypes2.default.string,
    pinterestIcon: _propTypes2.default.oneOf(['default', 'p', 'square']),
    pinterestImage: _propTypes2.default.string,
    pinterestMessage: _propTypes2.default.string,
    pinterestUrl: _propTypes2.default.string,
    twitterIcon: _propTypes2.default.oneOf(['default', 'square']),
    twitterMessage: _propTypes2.default.string,
    twitterUrl: _propTypes2.default.string,
    services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'facebook', 'pinterest', 'print', 'twitter']))
  }),
  socialEnabled: _propTypes2.default.bool
};
exports.default = Recipe;